import React, { useState, useCallback } from "react";
import useStyles from "./style";
import {
  Grid,
  TextField,
  Button,
  Typography,
  InputAdornment,
  InputLabel
} from "@mui/material";
import { useTheme } from "@mui/styles";
import Checkbox from "@mui/material/Checkbox";
import { useFormik } from "formik";
import * as yup from "yup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import loginApi from "../../Services/Login";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { showSnackbar } from "../../Redux/SnackBar/actions";
import { showLoader, hideLoader } from "../../Redux/Loader/actions";
import { setNewSiteLogo } from "Redux/SiteSettings/actions";
import { setNewtimezone , setSystemlatitude , setSystemlongitude } from "Redux/TimeZone/actions";
 import { setAuthentication } from "../../Redux/Authentication/actions";

import { CUSTOM_CONSTANTS } from "../../Constants";

import { makeStyles } from "@mui/styles";

//

import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

import settingsApi from "Services/Settings";


const Login = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
    const siteNewL = useSelector( 
      (state) => state?.SiteSettingsReducer?.siteNewLogo
    );
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  const [values, setValues] = useState([]);

  const handleLogin = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    const data = {
      email: formValues?.email,
      password: formValues?.password,
      userType: selectedOption,
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      dispatch(setAuthentication(res?.data?.data));
      dispatch(
        showSnackbar({
          message: res?.data?.message || "Logged in successfully",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );
      getMasterValues();
      getBusinessValues();
      navigate("/");
    };
    const onFailure = (err) => {
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while logging in",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      dispatch(hideLoader());
      //console.log("Login Api", err);
    };
    loginApi.login({ ...data }).then(onSuccess, onFailure);
  };

  // Set Settings

  const getMasterValues = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        //console.log("settings fetched ", res?.data?.data);
        dispatch(
          setNewSiteLogo(res?.data?.data?.siteLogo)
        );
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getMasterValues().then(onSuccess, onFailure);
  }, []);
  
  const getBusinessValues = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
       // console.log("settings fetched ", res?.data?.data);
         dispatch(setNewtimezone(res?.data?.data?.timeZone));
         dispatch(setSystemlatitude(res?.data?.data?.latitude));
        dispatch(setSystemlongitude(res?.data?.data?.longitude));
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getBusinessSettings().then(onSuccess, onFailure);
  }, []);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      email: yup.string().required("Username/Email is required").nullable(),
      password: yup.string().required("Password is required").nullable(),
    }),
    onSubmit: handleLogin,
  });

  //Checkbox

  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  //
console.log(siteNewL)
  const [selectedOption, setSelectedOption] = useState("ADMIN");

  const [selectedOptionBtn, setSelectedOptionBtn] = useState("ADMIN");

  const handleOptionClick = (option) => {
    setSelectedOptionBtn(option);
    setSelectedOption(option);
  };

const options = [
"ADMIN",
"ACCOUNT MANAGER",
"DISPATCHER",
"SUB COMPANY",
"HOTEL",
"CORPORATE"
// "AGENCY",
// "CUSTOMER CARE",
// "DRIVER",
// "USER"
];

  // Theme primary color

  return (
    <>
      <form style={{ width: "100%" }}>
        <Grid item container className={classes.root}>
          <Grid
            item
            xs={12}
            
            className={classes.loginImageContainer}
          >
            <img
              src="/assets/images/Login_Banner.png"
              alt="login-image"
              className={classes.loginPageImage}
            />
            <div className={classes.overlayText}>
              <Grid container spacing={3}>

           
          <Grid sm={12} md={4}  xl={4}>
              <div className={classes.gridContainer}>
                <div className={classes.gridItem}>
                  <Typography variant="h3" className={classes.boldertext}>
                    Kick-off Your Business
                    <span className={classes.highlightText}> With</span>
                  </Typography>
                </div>
                <div className={classes.gridItem}>
                  <Typography variant="h2" className={classes.boldText}>
                    Rue Taxi
                  </Typography>
                </div>
              </div>
              </Grid>
               <Grid item sm={12} md={4} xl={4} className={classes.loginContainer}>
            <Grid
              container
              flexDirection={"column"}
              className={classes.loginWrapper}
            >
              <Grid item xs={12} className={classes.imgContainer}>
                  {siteNewL ? (
                              <img
                                src={siteNewL}
                                alt="site logo"
                                className={classes.logo}
                              />
                            ) : (
                            <img
                              src="/assets/images/logos/carstonelogo.png"
                              alt="Metuaa_logo"
                              className={classes.logo}
                            />
                            ) }
              </Grid>
              <h2 style={{ fontStyle: "bold" }}>Sign In</h2>
              <FormControl component="fieldset">
                <Grid container spacing={2}>
                  {options.map((option) => (
                    <Grid item key={option}>
                      <Button
                    variant={selectedOptionBtn === option ? "contained" : "outlined"}
  sx={{
    backgroundColor:
      selectedOptionBtn === option ? "#000" : "#fff",
    color: selectedOptionBtn === option ? "#fff" : "#000",
    borderColor: "#fff",
    "&:hover": {
      backgroundColor:
        selectedOptionBtn === option ? "#f0f0f0" : "rgba(255,255,255,0.1)",
    },
  }}
                        
                        onClick={() => handleOptionClick(option)}
                      
                      >
                    {option.charAt(0).toUpperCase() + option.slice(1).toLowerCase()}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </FormControl>
              <br></br>
              <Grid item xs={12}  className={classes.gridFields}>
                 <InputLabel shrink htmlFor="bootstrap-input" style={{color:"white"}}>
        Username/Email*
        </InputLabel>
                <TextField
                 className={classes.whiteBgBlackText_WhiteBorder}
                  name="email"
                  id="email"
                  value={formik?.values?.email}
                  onChange={formik?.handleChange}
                  type={"text"}
                  fullWidth
                  variant="outlined"
                  // label="Username/Email*"
                  placeholder="Username/Email*"
                  autoFocus
                  error={formik?.errors?.email && formik?.touched?.email}
                  helperText={
                    formik?.errors?.email &&
                    formik?.touched?.email &&
                    formik?.errors?.email
                  }
                />
              </Grid>
              <Grid item xs={12}  className={classes.gridFields}>
                 <InputLabel shrink htmlFor="bootstrap-input" style={{color:"white"}}>
         Password*
        </InputLabel>
                <TextField
                 className={classes.whiteBgBlackText_WhiteBorder}
                  name="password"
                  id="password"
                  value={formik?.values?.password}
                  onChange={formik?.handleChange}
                  type={showPassword ? "text" : "password"}
                  fullWidth
                  variant="outlined"
                  // label="Password*"
                  placeholder="Password*"
                  error={formik?.errors?.password && formik?.touched?.password}
                  helperText={
                    formik?.errors?.password &&
                    formik?.touched?.password &&
                    formik?.errors?.password
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        position="end"
                        className={classes.password}
                      >
                        {showPassword ? (
                          <VisibilityIcon
                            onClick={() => setShowPassword(false)}
                          />
                        ) : (
                          <VisibilityOffIcon
                            onClick={() => setShowPassword(true)}
                          />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <br></br>

              <Grid item
                container
                xs={12}
                sm={12}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Grid item xs={12}  style={{display:"flex",justifyContent:"center"}}>
                  <Button
                    type={"submit"}
                    fullWidth
                    size="large"
                    variant="contained"
                    onClick={formik?.handleSubmit}
                    style={{ padding: "10px", borderRadius: "25px" }}
                  >
                    Sign In
                  </Button>
                </Grid>

                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  className={classes.forgotPassWord}
                >
                  {/* <Typography
                    variant="body2"
                    className={classes.forgotLabel}
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      flexDirection: "column",
                      fontStyle: "bold",
                      fontSize: "16px",
                    }}
                  >
                    Forgot Password ?
                  </Typography> */}
                </Grid>
              </Grid>
              <br></br>
              <Grid item container>
                {/* <Grid item xs={12} md={12} lg={12} xl={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#fff",
                        }}
                      />
                    }
                    label="Remember Me"
                  />
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
               <Grid  sm={12} md={4} xl={4}>
              <div className={classes.gridContainer}>
                <div className={classes.gridItem}>
                  <Typography variant="h3">
                    <span className={classes.highlightTextBig}>Be Smart</span> &
                    Complete
                  </Typography>
                </div>
                <div className={classes.gridItem}>
                  <Typography variant="h3">Entrepreneur!!!</Typography>
                </div>
              </div>
              </Grid>

                 </Grid>
            </div>
          </Grid>
         
        </Grid>
      </form>
    </>
  );
};

export default Login;
